<template>
  <Header :qty="cartQty" @update-qty="updateQty"></Header>
  <router-view @update-qty="updateQty"></router-view>
  <GoTopButton/>
  <Footer/>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import GoTopButton from '@/components/GoTopButton.vue'

export default {
  components: {
    Header,
    Footer,
    GoTopButton
  },
  data () {
    return {
      cartQty: 0
    }
  },
  methods: {
    updateQty () {
      const url = `${process.env.VUE_APP_API}api/${process.env.VUE_APP_PATH}/cart`
      this.$http.get(url).then((response) => {
        this.cartQty = response.data.data.carts.length
      })
    }
  }
}
</script>
